import ToolbarButtonWithDropdown from '../../ToolbarButtonWithDropdown';
import { ColorPicker } from '../../pickers';
import styles from './styles.module.scss';

/**
 * @todo translations
 */
export default function ColorButton({ editor, position }) {
  return (
    <ToolbarButtonWithDropdown
      disabled={!editor.can().chain().focus().setHighlight().run()}
      aria-label="editor-color"
      position={position}
      dropdownComponent={
        <ColorDropdown
          onClickBackgroundColor={(color) =>
            editor.chain().focus().setHighlight({ color }).run()
          }
          onClickFontColor={(color) =>
            editor.chain().focus().setColor(color).run()
          }
        />
      }
      style={{ left: 0 }}
    >
      <span style={{ fontWeight: 'bold', backgroundColor: '#FF0' }}>A</span>
    </ToolbarButtonWithDropdown>
  );
}

function ColorDropdown({ onClickBackgroundColor, onClickFontColor }) {
  return (
    <div className={styles['color-pickers-container']}>
      <ColorPicker
        title="Color de fondo"
        resetColorText="Establecer transparente"
        resetColorValue="#FFFFFF00"
        onChange={onClickBackgroundColor}
      />

      <ColorPicker
        title="Color de fuente"
        resetColorText="Restaurar por defecto"
        resetColorValue="#000000"
        onChange={onClickFontColor}
      />
    </div>
  );
}
